module.exports = __webpack_public_path__ + "img/viewpoint-animate1.e158ee23.png";